<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage account types</small>
      </legend>
      <div></div>
      <div class="accounttypesLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading accounttypes...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemAccounttypes"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      ></vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Account code",
          field: "account_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by accounttype code"
          }
        },
        {
          label: "Account name",
          field: "account_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by account name"
          }
        },
        {
          label: "Submmitted by",
          field: "fullname",
          type: "text"
        }
      ]
    };
  },
  created() {
    this.loadAccounttypes();
  },
  computed: {
    ...mapGetters(["systemAccounttypes"])
  },
  methods: {
    ...mapActions(["loadAccounttypes"])
  }
};
</script>


// WEBPACK FOOTER //
// src/accounttypes/manageaccounttypes.vue